jQuery(document).ready(() => {
  if (jQuery('select[name="add_printer"]').length === 0) {
    return;
  }

  jQuery('select[name="add_printer"]').selectWoo({
    placeholder: "Selecteer een printer",
  });
});
